import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, InputGroup, InputGroupText } from "reactstrap";
import logolight from '../../assets/images/logo-light.png';
import logodark from '../../assets/images/logo-dark.png';
import { useDispatch } from "react-redux";
import { loginUser } from "../../store/actions";

const Login = () => {
    document.title = "Login | ONFON GROUP LEGAL - Admin";

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (response.ok) {
                dispatch(loginUser(data));
                navigate(`/verifyotp/${email}`);
            } else {
                console.log({data})
                setError(data.message || "Login failed. Please try again.");
            }
        } catch (err) {
            setError(`An error occurred: ${err.message}`);
        }
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="bg-pattern" style={{ height: "100vh" }}>
            <div className="bg-overlay"></div>
            <div className="account-pages pt-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8} xl={4}>
                            <Card className='mt-5'>
                                <CardBody className="p-4">
                                    <div className="text-center">
                                        <Link to="/">
                                            <img src={logodark} alt="" height="24" className="auth-logo logo-dark mx-auto" />
                                            <img src={logolight} alt="" height="24" className="auth-logo logo-light mx-auto" />
                                        </Link>
                                    </div>

                                    <h4 className="font-size-18 text-muted text-center mt-2">Welcome Back!</h4>
                                    <Form className="form-horizontal" onSubmit={handleLogin}>
                                        {error && <Alert color="danger">{error}</Alert>}

                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-4">
                                                    <Label className="form-label">Email</Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        value={email}
                                                        required
                                                    />
                                                </div>
                                                {/* <div className="mb-4">
                                                    <Label className="form-label">Password</Label>
                                                    <Input
                                                        name="password"
                                                        type="password"
                                                        placeholder="Enter Password"
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        value={password}
                                                        required
                                                    />
                                                </div> */}
                                                
                                                <div className="mb-4 position-relative">
                                                    <Label className="form-label">Password</Label>
                                                    <InputGroup>
                                                        <Input
                                                            name="password"
                                                            type={showPassword ? "text" : "password"} // Toggle between text and password
                                                            placeholder="Enter Password"
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            value={password}
                                                            required
                                                        />
                                                        <InputGroupText onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                                                            {/* Eye Icon */}
                                                            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                                                        </InputGroupText>
                                                    </InputGroup>
                                                </div>
                                                <div className="d-grid mt-4">
                                                    <button className="btn btn-primary waves-effect waves-light" type="submit">
                                                        Log In
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p className="text-white-50">
                                    Don't have an account? <Link to="/register" className="fw-medium text-primary">Contact Admin</Link>
                                </p>
                                <p className="text-white-50">© {new Date().getFullYear()} Onfon Group.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default Login;